import { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Text from '@mui/material/Typography';
import Button from '@mui/material/Button';

import { useFolderActions } from '../../actions/FolderActions';

export default function DeleteFolderDialog({ open, onClose, data }) {
  const { t } = useTranslation();
  const { folder, isProject, empty } = data;
  const [deleteError, setDeleteError] = useState(null);
  const navigate = useNavigate();
  const { deleteFolderAsync } = useFolderActions(folder?.id);

  const handleDelete = useCallback(async () => {
    try {
      await deleteFolderAsync();
      const isProject = folder?.folder_prefix?.split('/')?.length === 3;
      onClose();
      if (isProject) {
        navigate(`/`);
        return;
      }
      navigate(`/folders${folder.folder_prefix.slice(0, -1)}`);
    } catch (e) {
      if (e.response.status === 400) {
        setDeleteError(t('Mappen kan inte tas bort eftersom den inte är tom.'));
      }
    }
  }, [deleteFolderAsync, folder, navigate, t, onClose]);

  const handleClose = useCallback(() => {
    onClose();
    setDeleteError(null);
  }, [onClose]);

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>
        {t('Ta bort')} {isProject ? t('projekt') : t('mapp')}
      </DialogTitle>
      <DialogContent>
        {!empty && (
          <Text>
            {t(
              'Mappen är inte tom. Alla filer och undermappar kommer att försvinna.'
            )}
          </Text>
        )}
        <Text>
          {t('Är du säker på att du vill ta bort')}{' '}
          {isProject ? t('projektet') : t('mappen')}{' '}
          <strong>{folder?.name}</strong>?
        </Text>
        {deleteError && (
          <Text variant="body2" color="error">
            {deleteError}
          </Text>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>{t('Avbryt')}</Button>
        <Button variant="contained" color="error" onClick={handleDelete}>
          {t('Ta bort')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
